module.exports = "<p>\r\n  contractors works!\r\n</p>\r\n"